export default "__VITE_ASSET__BSBYYKt5__"